import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import useForm from '../../../../hooks/useForm';
import { FormField } from '@prosolve/common-components-ui'
import EventProductsList from "./EventProductList";

export default forwardRef(({
  eventData = {},
  eventProducts = [],
  onUpdate,
}, ref) => {
  const {
    deliveryNotes
  } = eventData

  const [updatedEventProducts, setUpdatedEventProducts] = useState(eventProducts)
  const eventProductsListRef = useRef(null)

  const formSchema = {
    requiredFields: ['deliveryNotes'],
    optionalFields: [],
    initData: {
      deliveryNotes: (deliveryNotes === 'Delivered as planned.' ? '' : deliveryNotes) || ''
    }
  };

  const formData = useForm(formSchema)

  const getData = (newerValues) => {
    return {
      ...formData.values,
      eventProducts: updatedEventProducts,
      ...(newerValues || {})
    }
  }
  
  useImperativeHandle(ref, () => {
    return {
      isValid: () => {
        const isFormValid = formData.isValid()
        const areEventProductsValid = eventProductsListRef.current?.isValid?.() ?? true
        return isFormValid && areEventProductsValid
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const handleProductListUpdate = (productList) => {
    setUpdatedEventProducts(productList)

    const newEventProducts = productList.map(p => ({ ...p }))
    newEventProducts.forEach(p => {
      //p.numberOfDeliveredUnits = p.numberOfDeliveredUnits || p.numberOfExpectedUnits
      p.actualDeliveryPriceTotal = null //p.expectedDeliveryPriceTotal
      p.status = "Delivered"
    })
    onUpdate(getData({
      eventProducts: newEventProducts
    }))
  }

  useEffect(() => {
    onUpdate(getData())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      <EventProductsList ref={eventProductsListRef} eventProducts={updatedEventProducts} onUpdate={handleProductListUpdate} />
      <div style={{ paddingTop: '10px'}}>
        Notes: Please share about why the visit plan changed (required)
      </div>
      <div>
        <FormField
          style={{ flex: 1 }}
          fieldId='deliveryNotes'
          type='textarea'
          placeholder=''
          formData={formData}
        />
      </div>
    </div>
  )
})
